import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {withAlert} from 'react-alert';
import {createUser} from "../auth/Auth";
import {postRequest} from "../routes/Routes";
import '../assets/css/Home.css';

class SignUp extends Component {
    constructor(props) {
        super(props);
        this.state = {passwordUnMatch: false};
    }

    render() {
        return (
            <div className="container">
                <div className="login-component">
                    <h1 className="heading">volkslanka</h1>
                    <h3 className="form-heading">Create your account</h3>
                    <form onSubmit={this.signupFunction}>
                        <div className="form-group">
                            <input className="form-control"
                                   placeholder='First Name*' id="firstName" required/>
                        </div>
                        <div className="form-group">
                            <input className="form-control"
                                   placeholder='Last Name*' id="lastName" required/>
                        </div>
                        <div className="form-group">
                            <input type="email" className="form-control"
                                   placeholder='Email Address*' id="email" required/>
                        </div>
                        <div className="form-group">
                            <input className="form-control" type="password"
                                   placeholder='Password*' id="password" minLength="8" required/>
                        </div>
                        <div className="form-group">
                            <input className="form-control" type="password"
                                   placeholder='Confirm Password*' id="confirmPassword" minLength="8" required/>
                        </div>
                        {this.state.passwordUnMatch &&
                        <div className="alert alert-danger" role="alert">
                            Passwords are not matching
                        </div>}
                        <button className="btn blue-button login-button">Sign Up</button>
                    </form>
                </div>
            </div>
        );
    }

    signupFunction = async (event) => {
        event.preventDefault();
        const password = event.target.password.value;
        const confirmPassword = event.target.confirmPassword.value;
        if (password !== confirmPassword) {
            this.setState({passwordUnMatch: true});
        } else {
            this.setState({passwordUnMatch: false});
            let values = {
                first_name: event.target.firstName.value,
                last_name: event.target.lastName.value,
                email: event.target.email.value,
                password: password,
                endpoint: '/api/users'
            };
            postRequest(values).then(response => {
                if (response.status === 200) {
                    if (response.data.error) {
                        this.props.alert.error(response.data.message);
                    } else {
                        createUser(response.data.user).then(() => {
                            this.props.history.go(
                                this.props.history.push({
                                    pathname: "/"
                                })
                            );
                        });
                    }
                } else {
                    this.props.alert.error(response.data.message);
                }
            });
        }
    }
}

export default withAlert()(withRouter(SignUp));
